

// "use client";

// import Link from "next/link";
// import { useEffect, useState } from "react";
// import { Headphones, Menu, X } from "lucide-react";



// export default function Navbar() {
//     const [isMenuOpen, setIsMenuOpen] = useState(false);

//     useEffect(() => {
//         document.body.style.overflow = isMenuOpen ? "hidden" : "";
//         return () => {
//             document.body.style.overflow = "";
//         };
//     }, [isMenuOpen]);

//     const handleNavClick = () => {
//         if (window.innerWidth < 1024) {
//             setIsMenuOpen(false);
//         }
//     };

//     const navLinks = [
//         { label: "Features", href: "/#features", isInternal: true },
//         { label: "App", href: "/#download", isInternal: true },
//         { label: "Compare", href: "/#comparison", isInternal: true },
//         { label: "FAQs", href: "/#faqs", isInternal: true },
//     ];

//     return (
//         <nav className="fixed left-0 top-0 z-50 w-screen backdrop-blur-md bg-black/40">

//             <div className="relative">

//                 <div className="mx-auto px-4 sm:px-6 lg:px-8 backdrop-blur-md bg-black/40">
//                     {/* Main Navbar Row */}
//                     <div className="flex items-center justify-between h-16 lg:h-20">
//                         {/* Logo Section */}
//                         <div className="flex flex-col   items-center mt-12 lg:mt-16 scale-100 lg:scale-100  mb-12 lg:mb-16 ">
//                             <Link href="/" className="flex flex-col items-start ">
//                                 <img
//                                     src="/images/arzenlogowithtextcrop.avif"
//                                     alt="Zenithra Logo"
//                                     className="w- h-10  cursor-pointer  ml-5 md:px-6 "
//                                 />
//                             </Link>
//                         </div>

//                         {/* Desktop Navigation view */}
//                         <div className="hidden lg:flex items-center gap-[40px] mr-10">
//                             {navLinks.map(({ label, href }) => (
//                                 <Link
//                                     key={label}
//                                     href={href}
//                                     className="text-[#FFFFFF] hover:text-white font-medium text-[16px] tracking-wide transition-all duration-200

//                  hover:drop-shadow-[0_0_6px_rgba(255,255,255,0.5)]"
//                                 >
//                                     {label}
//                                 </Link>
//                             ))}
//                         </div>



//                         {/* Desktop Actions */}
//                         <div className="hidden lg:flex items-center space-x-4 mr-14">
//                             <Link href="/contact">
//                                 <div
//                                     className="rounded-full p-[1px]"
//                                     style={{
//                                         background: "linear-gradient(135deg, #666666, #333333, #666666)",
//                                     }}
//                                 >
//                                     <button className="bg-black rounded-full px-6 py-2 flex items-center gap-2 text-white hover:bg- transition-colors">
//                                         <Headphones size={20} />
//                                         <span className="hidden sm:inline">Support</span>
//                                     </button>
//                                 </div>
//                             </Link>
//                         </div>


//                         {/* Mobile Menu Button */}
//                         <div className="lg:hidden flex items-center space-x-2 overflow-hidden">
//                             <button
//                                 onClick={() => setIsMenuOpen(!isMenuOpen)}
//                                 className="p-2 text-gray-400 hover:text-white focus:outline-none"
//                             >
//                                 {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Mobile Menu view */}
//             <div
//                 className={`lg:hidden transition-all duration-300 ease-in-out ${isMenuOpen
//                     ? "max-h-screen opacity-100 pb-6"
//                     : "max-h-0 opacity-0 overflow-hidden"
//                     }`}
//             >
//                 <div className="border-t border-gray-800 pt-6">
//                     <div className="space-y-4 mb-6">
//                         {navLinks.map(({ label, href }) => (
//                             <div key={label}>
//                                 <Link
//                                     href={href}
//                                     className="text-gray-300 hover:text-white font-medium py-2 px-4 rounded-lg hover:bg-white/5 transition-all duration-200 flex items-center gap-2"
//                                     onClick={handleNavClick}
//                                 >
//                                     {label}
//                                 </Link>
//                             </div>
//                         ))}
//                     </div>
//                     {/* <div className="space-y-4 pt-4 border-t border-gray-800">
//                         <Link href="/support">
//                             <button
//                                 className="bg-gradient-to-r border-l-[#353533] border-r-[#8E8E8E] from-[#8E8E8E] to-[#353533] text-white ml-2 px-8 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl w-full"
//                                 onClick={handleNavClick}
//                             >
//                                 Support
//                             </button>
//                         </Link>
//                     </div> */}
//                     <div className="space-y-4 pt-4 border-t border-gray-800 px-4">
//                         <Link href="/contact" onClick={handleNavClick}>
//                             <div
//                                 className="rounded-full p-[1px] w-full"
//                                 style={{
//                                     background: "linear-gradient(135deg, #666666, #333333, #666666)",
//                                 }}
//                             >
//                                 <button className="bg-black rounded-full w-full py-2.5 flex justify-center items-center gap-2 text-white hover:bg-neutral-900 transition-all duration-200">
//                                     <Headphones size={20} />
//                                     <span>Support</span>
//                                 </button>
//                             </div>
//                         </Link>
//                     </div>
//                 </div>
//             </div>
//         </nav>
//     );
// }















"use client";

import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useRef, useEffect, useState } from "react";
import { Headphones, Menu, X } from "lucide-react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const scrollTargetRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const targetId = href.replace("/#", "");
    console.log("Navigating to:", targetId);
    console.log("Current path:", window.location.pathname);
    if (window.location.pathname === "/") {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const headerOffset = document.querySelector("nav")?.offsetHeight || 100; // dynamic height detection
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }

    } else {
      console.log("Storing scroll target and navigating to home");
      scrollTargetRef.current = targetId;
      router.push("/");
    }

    if (window.innerWidth < 1024) setIsMenuOpen(false);
  };

  useEffect(() => {
    if (pathname !== "/" || !scrollTargetRef.current) return;

    const targetId = scrollTargetRef.current;
    console.log(`[Navbar] Arrived at home, waiting for #${targetId} to appear...`);

    let attempts = 0;
    const maxAttempts = 40; // ~4 seconds
    const interval = setInterval(() => {
      const el = document.getElementById(targetId);
      attempts++;
      if (el) {

        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          scrollTargetRef.current = null;
        }, 500);
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        console.warn(`[Navbar] Gave up waiting for #${targetId} after ${maxAttempts} tries.`);
        scrollTargetRef.current = null;
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [pathname]);

  const navLinks = [
    { label: "Features", href: "/#features" },
    { label: "App", href: "/#download" },
    { label: "Compare", href: "/#comparison" },
    { label: "FAQs", href: "/#faqs" },
  ];

  return (
    <nav className="fixed left-0 top-0 z-50 w-screen backdrop-blur-md bg-black/40" style={{ WebkitBackdropFilter: "blur(12px)", backdropFilter: "blur(12px)" }}>
      <div className="relative">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 backdrop-blur-md bg-black/40">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <div className="flex flex-col items-center mt-12 lg:mt-16 mb-12 lg:mb-16">
              <Link href="/" className="flex flex-col items-start">
                <img
                  src="/images/arzenlogowithtextcrop.avif"
                  alt="Zenithra Logo"
                  className="w-auto h-10 cursor-pointer ml-5 md:px-6"
                />
              </Link>
            </div>

            {/* Desktop nav */}
            <div className="hidden lg:flex items-center gap-[40px] mr-10">
              {navLinks.map(({ label, href }) => (
                <Link
                  key={label}
                  href={href}
                  onClick={(e) => handleNavClick(e, href)}
                  className="text-[#FFFFFF] hover:text-white font-medium text-[16px] tracking-wide transition-all duration-200 hover:drop-shadow-[0_0_6px_rgba(255,255,255,0.5)]"
                >
                  {label}
                </Link>
              ))}
            </div>

            {/* Desktop actions */}
            <div className="hidden lg:flex items-center space-x-4 mr-14">
              <Link href="/contact">
                <div
                  className="rounded-full p-[1px]"
                  style={{
                    background:
                      "linear-gradient(135deg, #666666, #333333, #666666)",
                  }}
                >
                  <button className="bg-black rounded-full px-6 py-2 flex items-center gap-2 text-white hover:bg-neutral-900 transition-colors">
                    <Headphones size={20} />
                    <span className="hidden sm:inline">Support</span>
                  </button>
                </div>
              </Link>
            </div>

            {/* Mobile button */}
            <div className="lg:hidden flex items-center space-x-2 overflow-hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 text-gray-400 hover:text-white focus:outline-none"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile nav */}
      <div
        className={`lg:hidden transition-all duration-300 ease-in-out ${isMenuOpen
          ? "h-screen opacity-100 pb-6"
          : "max-h-0 opacity-0 overflow-hidden"
          }`}
      >
        <div className="border-t border-[rgba(219,219,219,0.15)] pt-6 h-full flex flex-col">
          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto px-4 space-y-4 mb-6">
            {navLinks.map(({ label, href }) => (
              <div key={label}>
                <Link
                  href={href}
                  onClick={(e) => handleNavClick(e, href)}
                  className="text-gray-300 hover:text-white font-medium py-2 px-4 rounded-lg hover:bg-white/5 transition-all duration-200 flex items-center gap-2"
                >
                  {label}
                </Link>
              </div>
            ))}
          </div>

          {/* Support button pinned at bottom */}
          <div className="px-4 py-4 sticky bottom-0">
            <Link href="/contact" onClick={() => setIsMenuOpen(false)}>
              <div
                className="rounded-full p-[1px] w-full  bg-black"
                style={{
                  background: "black",
                }}
              >
                <button className="bg-black rounded-full w-full py-2.5 flex justify-center items-center gap-2 text-white hover:bg-neutral-900 transition-all duration-200">
                  <Headphones size={20} />
                  <span>Support</span>
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>


    </nav>
  );
}
